import React, { useState, useEffect } from 'react';
import { Button, Form, Input, InputNumber, DatePicker, Select, Modal, Checkbox } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { composeSelectOptions } from '../utils/ComponentUtils';
import { api } from '../AppConfig';
import { useTranslation } from 'react-i18next';

function AddSeason(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [leagues, setLeagues] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
      fetch(api.leagues().list({'active':true}).href, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
          },
        })
      .then(res => res.json())
      .then(
        (result) => {
          setLeagues(result.payLoad);
        },
        (error) => {
          // console.warn('AddSeason Error:', error);
        }
      )
    }, [])

    function toggleModal() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
      setIsActive(false);
      form.resetFields();
    }

    async function onFinish(values) {
        setConfirmLoading(true);
        const stringDate = values.startDate.format('YYYY-MM-DDTHH:mm:ssZ');
        values.startDate = stringDate;
        const sd2 = values.endDate.format('YYYY-MM-DDTHH:mm:ssZ');
        values.endDate = sd2;
        
        const response = await fetch(api.seasons().create().href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(values) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())
        .catch((error) => console.error(error))
        // .then((data) => window.location.reload(false))

        // window.location.reload(false);
    }

    return(
            <div>
              <Modal title={t('seasons.create')} open={isActive} trigger="click" confirmLoading={confirmLoading} onOk={form.submit} onCancel={handleCancel} cancelText={t('common.cancel')} okText={t('common.generate')}>
                <Form form={form} onFinish={onFinish}>
                    <Form.Item label={t('seasons.labelName')} name="name" rules={[{ required: true, message: t('common.requiredField') }]}>
                        <Input placeholder={t('seasons.labelName')} />
                    </Form.Item>
                    <Form.Item label={t('leagues.label')} name="leagueId" rules={[{ required: true, message: t('common.requiredField') }]}>
                        <Select placeholder={t('leagues.labelName')}>
                            {composeSelectOptions(leagues,{key: 'id', value: 'id', desc: 'leagueName'})}
                        </Select>
                    </Form.Item>
                    <Form.Item label={t('seasons.startDate')} name="startDate" rules={[{ required: true, message: t('common.requiredField') }]}>
                        <DatePicker format="DD/MM/YYYY" />
                    </Form.Item>
                    <Form.Item label={t('seasons.endDate')} name="endDate" rules={[{ required: true, message: t('common.requiredField') }]}>
                        <DatePicker format="DD/MM/YYYY" />
                    </Form.Item>
                    <Form.Item 
                      label={t('stages.total')} 
                      tooltip="Put the number of expected stages you will schedule in the season."
                      name="scheduledStages" 
                      rules={[{ required: true, message: t('common.requiredField') }]}
                    >
                        <InputNumber placeholder={t('stages.total')} style={{ width: '100%' }} min={5}/>
                    </Form.Item>
                    <Form.Item 
                      label={t('stages.valid')} 
                      tooltip="The number of valid stages to count point from. For each player the worst results will be excluded"
                      name="bestStages" 
                      rules={[{ required: true, message: t('common.requiredField') }]}
                    >
                        <InputNumber placeholder={t('stages.valid')} style={{ width: '100%' }} min={5}/>
                    </Form.Item>
                    <Form.Item
                      label={t('seasons.participationBonus')}
                      tooltip="Assign a bonus for stage participation to the players?"
                      name="rankingBonus"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                    <Form.Item 
                      label={t('seasons.bonusCap')} 
                      tooltip="Set a cap for the participation bonus points"
                      name="rankingBonusCap"
                    >
                      <InputNumber placeholder="0" style={{ width: '100%' }} min={0}/>
                    </Form.Item>
                </Form>
              </Modal>
              <Button style={{ marginTop: 16 }} type="primary" icon={<PlusOutlined />} onClick={toggleModal}>
                  {t('seasons.create')}
              </Button>
            </div>
    )
}

export default AddSeason;